<pbc-filter [config]="ObjekteFilterConfig" [filter]="objekte.filter$ | async" (filterChange)="objekte.filter$.next($event)"></pbc-filter>
